export interface CategoryItem {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
  accent: "primary" | "accent" | "secondary";
}

export const communityCategories: CategoryItem[] = [
  {
    slug: "daily",
    name: "今日瓜田",
    desc: "当天最热闹的日常趣闻，围观群众的第一现场。",
    icon: "ri-plant-line",
    count: 1284,
    accent: "primary",
  },
  {
    slug: "essence",
    name: "神回复合集",
    desc: "高赞神回复、金句与加精热评的集中营。",
    icon: "ri-chat-quote-line",
    count: 963,
    accent: "accent",
  },
  {
    slug: "workplace",
    name: "职场观察",
    desc: "工位、会议与通勤路上的观察笔记。",
    icon: "ri-briefcase-4-line",
    count: 742,
    accent: "secondary",
  },
  {
    slug: "neighbor",
    name: "邻里生活",
    desc: "楼道、小区与街角的温暖日常。",
    icon: "ri-home-smile-line",
    count: 618,
    accent: "primary",
  },
  {
    slug: "campus",
    name: "校园故事",
    desc: "教室、宿舍与社团里的青春片段。",
    icon: "ri-graduation-cap-line",
    count: 505,
    accent: "accent",
  },
  {
    slug: "memes",
    name: "网络热梗",
    desc: "最近火起来的梗，以及它背后的故事。",
    icon: "ri-fire-line",
    count: 431,
    accent: "secondary",
  },
  {
    slug: "life",
    name: "生活灵感",
    desc: "把随手的小事，过成值得记录的样子。",
    icon: "ri-lightbulb-flash-line",
    count: 366,
    accent: "primary",
  },
  {
    slug: "city",
    name: "城市角落",
    desc: "在城市里遇到的人，和留下来的瞬间。",
    icon: "ri-building-2-line",
    count: 298,
    accent: "accent",
  },
];